import { render } from "./CategoryKeywords.vue?vue&type=template&id=424d5a10"
import script from "./CategoryKeywords.vue?vue&type=script&lang=ts"
export * from "./CategoryKeywords.vue?vue&type=script&lang=ts"

import "./CategoryKeywords.vue?vue&type=style&index=0&id=424d5a10&lang=scss"
script.render = render

export default script